import { render } from "./edit-form-field.vue?vue&type=template&id=7c07a0d3"
import script from "./edit-form-field.vue?vue&type=script&lang=js"
export * from "./edit-form-field.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__